import { isArray, isEmpty, trim, getByteLen } from '@/common/js/utils'

export default {
  methods: {
    changScene(val) {
      let ftypes = []
      if (val === 2) {
        ftypes = [1, 2, 8, 64]
        this.$set(this.formItem, 'producttypes', 0)
      } else if (val === 4) ftypes = [4]
      this.$set(this.formItem, 'ftypes', ftypes)
    },
    changeFtypes(val) {
      const some = val.some((ret) => ret > 2)
      if (this.formItem.producttypes && some) this.$set(this.formItem, 'producttypes', 0)
    },
    addTitleList(ret) {
      const title = ret && ret.docContent
      const val = typeof title === 'string' ? title : ''
      this.formItem.titleList.push({ title: val })
    },
    delTitleList(index) {
      console.log('index output: ', index)
      this.formItem.titleList.splice(index, 1)
    },
    addCreative(type) {
      let param = { name: type }
      if (type === 'video') {
        const mult = 6 - this.formItem.videoCreative.length
        param = Object.assign({}, param, {
          mult,
          batch: true,
          type: 'ELEMENT_TYPE_VIDEO',
          width: 1280,
          height: 720,
          size: 102400
        })
      } else if (type === 'large') {
        const mult = 6 - this.formItem.largeCreative.length
        param = Object.assign({}, param, {
          mult,
          batch: true,
          type: 'ELEMENT_TYPE_IMAGE',
          width: 1140,
          height: 640,
          size: 500
        })
      } else if (type === 'image') {
        const mult = 6 - this.formItem.imageCreative.length
        param = Object.assign({}, param, {
          mult,
          batch: true,
          type: 'ELEMENT_TYPE_IMAGE',
          width: 370,
          height: 245,
          size: 100
        })
      } else if (type === 'group') {
        param = Object.assign({}, param, {
          mult: 3,
          batch: true,
          type: 'ELEMENT_TYPE_IMAGE',
          width: 370,
          height: 245,
          size: 100
        })
      } else if (type === 'logo') {
        param = Object.assign({}, param, {
          mult: 1,
          batch: false,
          type: 'ELEMENT_TYPE_LOGO',
          width: 120,
          height: 120,
          size: 1024
        })
      }
      this.selectImage(param)
    },
    deleteItem({ type, id }) {
      this.formItem[`${type}Creative`].splice(id, 1)
    },
    invalidPlus(ret, rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? ret[rule.name.split('/')[0]][rule.name.split('/')[1]] : ret[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = rule.charset === 'init' ? getByteLen(param, 1) : getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? ret[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : ret[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isArray(param) && !param.length) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (param && rule.max < length) {
          const msg = `${rule.desc}不能多于${rule.max}个字符`
          arr.push({ feild: rule.desc, msg })
          continue
        }
        if (param && rule.min > length) {
          const msg = `${rule.desc}不能少于${rule.min}个字符`
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 正则
        if (param && rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    validLen(ret) {
      const err = []
      const someTitLen = ret.titleList.some((met) => getByteLen(met.title) > 60)
      const creatives = [...ret.videoCreative, ...ret.largeCreative, ...ret.imageCreative, ...ret.groupCreative]
      if (ret.videoCreative.length > 6) err.push({ feild: '创意素材', msg: '视频创意素材不能超过6个！' })
      if (ret.largeCreative.length > 6) err.push({ feild: '创意素材', msg: '大图创意素材不能超过6个！' })
      if (ret.imageCreative.length > 6) err.push({ feild: '创意素材', msg: '小图创意素材不能超过6个！' })
      if (ret.groupCreative.length > 6) err.push({ feild: '创意素材', msg: '组图创意素材不能超过6组！' })
      if (!creatives.length) err.push({ feild: '创意素材', msg: '创意素材不能为空！' })
      if (someTitLen) err.push({ feild: '标题', msg: '每个标题长度不能超过60个字符！' })
      return err
    },
    invalidExtand(ret) {
      const source = ret.creativeDetails
      const creatives = [...ret.videoCreative, ...ret.largeCreative, ...ret.imageCreative, ...ret.groupCreative]

      return creatives.map((creative) => {
        let errMsg
        const err = creative.template.map((met) => {
          let stat
          if (['image', 'video', 'cover'].includes(met.name)) {
            if (met.required && isEmpty(met[met.name])) stat = false
            else if (['image', 'cover'].includes(met.name)) {
              let fileSize, Width, Height
              const { size: file_size, width, height } = met.restriction
              const index = source.findIndex((ret) => ret.image_token === met[met.name])
              const {
                type,
                file_size: realFileSize,
                width: fileWidth,
                height: fileHeight,
                cover_size: coverSize,
                cover_width: coverWidth,
                cover_height: coverHeight
              } = source[index]
              if (type === 'video') {
                // 默认封面
                fileSize = coverSize
                Width = coverWidth
                Height = coverHeight
              } else {
                fileSize = realFileSize
                Width = fileWidth
                Height = fileHeight
              }
              if (fileSize > file_size * 1024 || width !== Width || height !== Height) {
                stat = false
                errMsg = `${type === 'video' ? '视频封面' : '图片'}尺寸超出限制，请重新选择`
              } else stat = true
            } else if (met.name === 'video') {
              const { file_size, width, height } = met.restriction
              const index = source.findIndex((ret) => ret.photo_id === met[met.name])
              const { file_size: fileSize, width: Width, height: Height } = source[index]
              if (fileSize > file_size * 1024 || Width !== width || Height !== height) {
                stat = false
                errMsg = '封面尺寸超出限制，请重新选择'
              } else stat = true
            }
          } else if (['package'].includes(met.name)) {
            stat = met.children.every((t) => {
              return t.required ? !isEmpty(t[t.name]) : true
            })
          }
          return stat
        })
        return { stat: err, mode: creative.mode, errMsg }
      })
    }
  }
}
